module.exports = __webpack_public_path__ + "static/media/Play_Store_Badge.d633e4d6.svg";